import { render } from "./SelectedShopPage.vue?vue&type=template&id=3d4f0484&scoped=true"
import script from "./SelectedShopPage.vue?vue&type=script&lang=js"
export * from "./SelectedShopPage.vue?vue&type=script&lang=js"

import "./SelectedShopPage.vue?vue&type=style&index=0&id=3d4f0484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4f0484"]])

export default __exports__